import { createContext } from 'react';

export const ThemeContextAction = createContext<any | undefined>(undefined);
export const ThemeContextValue = createContext<any | undefined>(undefined);

export const ThemeContext = {
  Action: ThemeContextAction,
  Value: ThemeContextValue,
};
